export enum TemplateFilterAnimatedTypeEnum {
  All = 'all',
  Animated = 'animated',
  Still = 'still',
}
